<template>
  <section class="content-terms container">
    <div class="content-terms--text">
      <h1>Termos e Condições</h1>
      <p>Os presentes Termos e Condições regulam o uso do aplicativo Evolution ou Salon Date fornecido por Alpha Softwares, com sede em Belo Horizonte, Minas Gerais - Brasil, doravante referido como "Fornecedor" ou "nós". Ao baixar, instalar ou usar o Aplicativo, você concorda em cumprir estes Termos. Se você não concorda com estes Termos, por favor, não utilize o Aplicativo.</p>
      <h2>1. Uso do Aplicativo:</h2>
        <p>1.1. O Aplicativo destina-se exclusivamente para fins de desenvolvimento pessoal, autoaperfeiçoamento, aprendizado e bem-estar.</p>
        <p>1.2. Você concorda em usar o Aplicativo de acordo com todas as leis e regulamentos aplicáveis. Você é o único responsável por qualquer atividade realizada em sua conta.</p>
        <p>1.3. Você não deve usar o Aplicativo para qualquer finalidade ilegal, prejudicial, difamatória, abusiva, ameaçadora, assediante, prejudicial, invasiva da privacidade de terceiros ou de outra forma inaceitável.</p>
      <h2>2. Conteúdo:</h2>
        <p>2.1. O Aplicativo pode conter artigos, vídeos, áudios, exercícios e outros materiais relacionados ao desenvolvimento pessoal. O Fornecedor não garante a exatidão, integridade ou utilidade desse conteúdo.</p>
        <p>2.2. O conteúdo do Aplicativo não substitui aconselhamento profissional. Você é responsável por procurar orientação profissional, quando necessário, antes de tomar decisões baseadas no conteúdo do Aplicativo.</p>
      <h2>3. Privacidade:</h2>
        <p>3.1. O Fornecedor pode coletar e processar informações pessoais de acordo com a Política de Privacidade. Ao utilizar o Aplicativo, você consente com a coleta e processamento dessas informações, conforme descrito na Política de Privacidade.</p>
      <h2>4. Conta do Usuário:</h2>
        <p>4.1. Para acessar alguns recursos do Aplicativo, você pode ser obrigado a criar uma conta de usuário. Você é responsável por manter a confidencialidade das informações de sua conta e por todas as atividades que ocorram sob sua conta.</p>
        <p>4.2. Você concorda em fornecer informações precisas, atualizadas e completas ao criar sua conta.</p>
      <h2>5. Propriedade Intelectual:</h2>
        <p>5.1. O Aplicativo e todo o conteúdo associado, incluindo mas não se limitando a gráficos, logotipos, textos e recursos interativos, são propriedade exclusiva do Fornecedor ou de seus licenciadores e estão protegidos por direitos autorais e outras leis de propriedade intelectual.</p>
        <p>5.2. Você não tem permissão para copiar, reproduzir, distribuir, transmitir, exibir, vender, licenciar ou explorar comercialmente qualquer parte do Aplicativo sem autorização prévia por escrito do Fornecedor.</p>
      <h2>6. Rescisão:</h2>
        <p>6.1. O Fornecedor reserva-se o direito de suspender ou encerrar sua conta e acesso ao Aplicativo a qualquer momento, por qualquer motivo, sem aviso prévio.</p>
      <h2>7. Alterações nos Termos:</h2>
        <p>7.1. O Fornecedor pode alterar estes Termos a qualquer momento. Quaisquer alterações serão publicadas no Aplicativo. O uso contínuo do Aplicativo após tais alterações constitui sua aceitação dos novos Termos.</p>
      <h2>8. Disposições Gerais:</h2>
        <p>8.1. Estes Termos constituem o acordo completo entre você e o Fornecedor em relação ao uso do Aplicativo.</p>
        <p>8.2. Se qualquer disposição destes Termos for considerada inválida ou inexequível, as demais disposições permanecerão em pleno vigor e efeito.</p>
        <p>8.3. Estes Termos são regidos pelas leis do Brasil e qualquer disputa decorrente ou relacionada a estes Termos estará sujeita à jurisdição exclusiva dos tribunais competentes do Brasil.</p>
        <p>Ao utilizar o Aplicativo, você reconhece ter lido, entendido e concordado com estes Termos e Condições. Se você não concordar com estes Termos, por favor, não utilize o Aplicativo.</p>
    </div>
  </section>
</template>

<script>

export default {
}
</script>

<style lang="scss">
.content-terms {
  padding-top: 70px;
  padding-bottom: 150px;
  @media (max-width: 767px){
    padding: 50px 30px 150px 30px;
  }
  &--text {
    text-align: left;
    margin-bottom: 30px;
    h1 {
      font-size: 24px;
      font-family: 'Font Semibold';
      color: var(--black);
      line-height: 1;
      margin-bottom: 30px;
    }
    h2 {
      font-size: 20px;
      font-family: 'Font Semibold';
      color: var(--black);
      line-height: 1;
      margin: 30px 0px;
    }
    p {
      font-size: 16px;
      font-family: 'Font Light';
      color: var(--black);
      margin-bottom: 15px;
    }
    ul li {
      font-size: 14px;
      font-family: 'Font Light';
      color: var(--black);
      margin-bottom: 15px;
    }
  }
}
</style>
